import { ProofOfDeliveryBean } from "./proof-of-delivery";

export class BookingArriveRequest {
  bookingNo: string
  userId: string
  facility: string
  docReference: string;
  podList: ProofOfDeliveryBean[]

  constructor() {
    this.bookingNo = '';
    this.userId = '';
    this.facility = '';
    this.docReference = '';
    this.podList = [];
  }
}
